import { render, staticRenderFns } from "./signInDetail.vue?vue&type=template&id=16067b2c&scoped=true&"
import script from "./signInDetail.vue?vue&type=script&lang=js&"
export * from "./signInDetail.vue?vue&type=script&lang=js&"
import style0 from "./signInDetail.vue?vue&type=style&index=0&id=16067b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16067b2c",
  null
  
)

export default component.exports